export default __webpack_public_path__ + "assets/images/Seen-02fb05c55b1545221ceed3273e4c8366.svg";